import { render } from "./MiniMap.vue?vue&type=template&id=c80d13e4&scoped=true"
import script from "./MiniMap.vue?vue&type=script&lang=js"
export * from "./MiniMap.vue?vue&type=script&lang=js"

import "./MiniMap.vue?vue&type=style&index=0&id=c80d13e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80d13e4"]])

export default __exports__